import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, type OnInit } from '@angular/core';
import { FilialService } from '@zaoblako/web/core/services/finance/filial.service';
import { GlobalService } from '@zaoblako/web/core/services/global.service';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { StandardSingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/standard-dropdown/standard-single-select/standard-single-select.component';
import type { FilialFindInterface } from '@zaoblako/shared/modules/catalog/dtos/filial/filial-find.dto';

/**
 * @deprecated Use `crm-standard-single-select` and `FilialService.dropdownDescriptorUrl`.
 */
@Component({
  selector: 'crm-filial-single-select',
  standalone: true,
  imports: [SingleSelectComponent, StandardSingleSelectComponent],
  templateUrl: './filial-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilialSingleSelectComponent implements OnInit {
  @Input() public filials: FilialFindInterface[] = [];
  @Input() public selectedFilial: FilialFindInterface;
  @Output() public selectedFilialChange = new EventEmitter<FilialFindInterface>();
  @Output() public changeValue = new EventEmitter<FilialFindInterface>();
  @Input() public customRequest = false;
  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public showClear = false;
  @Input() public disabled = false;
  @Input() public isError = false;
  @Input() public appendTo: string;

  public loading = false;
  public useStandard = false;
  public readonly descriptorUrl: string;

  public constructor(
    filialService: FilialService,
    private readonly globalService: GlobalService
  ) {
    this.descriptorUrl = filialService.dropdownDescriptorUrl;
  }

  public ngOnInit(): void {
    this.useStandard = !this.customRequest && !!this.globalService.globalInfo?.tenantInfo?.ratePlan?.modulesAccessControl?.BASIS?.enabled;
  }

  public onSelected = (filial: FilialFindInterface): void => {
    this.selectedFilial = filial;
    this.selectedFilialChange.emit(filial);
    this.changeValue.emit(filial);
  };
}
